import React from "react";
import common from "tools/common";

import SearchBar from "components/Tools/SearchBar";

function SearchWidget(props) {
  const { handleFilter, ctxView } = props;

  let searchables = [];
  for (const [field, attrs] of Object.entries(ctxView.webfields)) {
    if (attrs.searchable) {
      searchables.push({
        name: field,
        type: attrs.type,
      });
    }
  }

  function makeDomain(textMap) {
    console.log("textMap ....", textMap);
    let arrText = textMap.split(" ");
    let domain = [];
    for (const tw of arrText) {
      let clause = ["OR"];
      for (const field of searchables) {
        let field_name = field.name;
        if (field.type === "many2one") {
          field_name = field_name + ".rec_name";
        }
        if (field.type === "date") {
          const n = common.getTrytonDate2Js(tw);
          if (!isNaN(n)) {
            clause.push([field_name, "=", tw]);
          }
        } else {
          clause.push([field_name, "ilike", `%${tw}%`]);
        }
      }
      domain.push(clause);
    }
    return domain;
  }

  function handleSearch(textSearch) {
    let dom = [];
    if (searchables && searchables.length > 0 && textSearch !== "") {
      dom = makeDomain(textSearch, searchables);
    }

    if (props.domain) {
      dom.push(props.domain[0]);
    }

    if (dom.length > 0) {
      handleFilter(dom);
    }
  }

  return (
    <div className="flex col-span-6 md:col-span-2">
      <SearchBar
        name="search-widget"
        handleSearch={handleSearch}
        size="w-full"
      />
    </div>
  );
}

export default SearchWidget;
